import script from "./AutoTaskLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoTaskLayout.vue?vue&type=script&setup=true&lang=js"

import "./AutoTaskLayout.vue?vue&type=style&index=0&id=8a3874c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a3874c6"]])

export default __exports__